/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-useless-escape */
import { InjectionToken } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroupDirective,
  NgForm,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileOpener } from '@capacitor-community/file-opener';
import { AppLauncher } from '@capacitor/app-launcher';
import { Browser } from '@capacitor/browser';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { ConfirmResult, Dialog } from '@capacitor/dialog';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ITranslationService } from 'angular-i18next';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import Quill from 'quill';
import { OpenSnackBarService } from 'src/app/common/open-snack-bar/open-snack-bar.service';
import { UserService } from 'src/app/common/user/user.service';
import { environment } from 'src/environments/environment';
import { NearFilter, SearchComparator, SearchNode, SharryContentStatus, SortFilter } from 'src/types/graphql';

export const MAT_SNACK_BAR = new InjectionToken<MatSnackBar>('snackbar');

export const getTimeOptions = (): Map<string, string[]> => {
  const timeOptions: Map<string, string[]> = new Map();
  const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < minutes.length; m++) {
      timeOptions.set(`${h < 10 ? '0' : ''}${h}`, minutes);
    }
  }
  return timeOptions;
};

export const markCategoriesAsSelected = (
  selectedCategories: any[],
  arrayToMark: any[],
  nestedField?: string | undefined,
) => {
  selectedCategories.forEach(category => {
    const index = arrayToMark.findIndex(c => (nestedField ? c.id === category[nestedField].id : c.id === category.id));
    if (arrayToMark[index]) {
      arrayToMark[index].selected = true;
      arrayToMark[index] = {
        ...category,
        ...arrayToMark[index],
      };
    }
  });
};

export const addHttp = (url: string) => {
  if (!url) return undefined;
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = 'https://' + url;
  }
  return url;
};

export const removeHttp = (url: string) => (url ? url.replace(/^https?\:\/\//i, '') : '');

export enum ScreenSizes {
  XXS = 480,
  XS = 600,
  SM = 768,
  MD = 1024,
  LG = 1450,
  XLG = 1910,
}

export enum ErrorMessageFieldnames {
  EMAIL = 'email',
  PASSWORD = 'password',
  PASSWORD_CONFIRMATION = 'passwordConfirmation',
  CURRENT_PASSWORD = 'currentPassword',
}

export interface NguTransform {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl?: number;
  all: number;
}

export const getErrorMessageFromData = (
  err: any,
  document: Document,
  fieldName?: ErrorMessageFieldnames | undefined,
): string => {
  let errorMessage = '';
  let errors;
  if (err.networkError && err.networkError.length > 0) {
    errors = err.networkError;
  } else if (err.graphQLErrors && err.graphQLErrors.length > 0) {
    errors = err.graphQLErrors;
  } else if (err.errors && err.errors.length > 0) {
    errors = err.errors;
  }
  if (errors) {
    let stop = false;
    for (let i = 0; i < errors.length && !stop; i++) {
      const field = errors[i].extensions ? errors[i].extensions.field : null;
      if (fieldName === field) {
        errorMessage = errors[i].message;
        stop = true;
      } else if (field === null || !fieldName) {
        errorMessage = errorMessage.concat(`${errors[i].message}\n`);
      }
    }
  } else {
    errorMessage = err.message;
  }
  if (errorMessage.length > 200) {
    errorMessage = `${errorMessage.substring(0, 200)}...`;
  }
  if (errorMessage.includes('Http failure response') && Capacitor.isNativePlatform()) {
    return 'ERROR_FROM_CAPACITOR';
  }
  if (
    errorMessage.includes('Failed to fetch') ||
    errorMessage.includes('Network error') ||
    errorMessage.includes('Load failed') ||
    errorMessage.includes('Http failure response')
  )
    errorMessage = 'Ops! C’è stato un piccolo intoppo. Riprova!';
  return errorMessage;
};
export const getDefaultModalSettings = (): MatDialogConfig => ({
  autoFocus: false,
  restoreFocus: false,
  width: '90vw',
  maxWidth: '512px',
  minHeight: '200px',
  maxHeight: '84vh',
});

export const groupSharryContentArrayPerTypename = (array: any[]) => {
  const result = groupArrayPerTypename(array);
  return [
    ...((result && result['Wonder']) || []),
    ...((result && result['Sharry']) || []),
    ...((result && result['Resource']) || []),
    ...((result && result['Recommendation']) || []),
  ];
};

export const groupArrayPerTypename = (array: any[]) =>
  array &&
  array.reduce((r, a) => {
    r[a.__typename] = r[a.__typename] || [];
    r[a.__typename].push(a);
    return r;
  }, Object.create(null));

export const splitSharryContentArrayByTypename = (array: any[], typename: string) => {
  const result = array.reduce((r, a) => {
    r[a.__typename] = r[a.__typename] || [];
    r[a.__typename].push(a);
    return r;
  }, Object.create(null));
  return [...(result[typename] || [])];
};

export const buildSearchQuery = (value: any) => {
  const or = [];
  or.push({
    query: {
      field: 'sharry_content_title',
      comparator: SearchComparator.ContWordStartsWith,
      value,
    },
  });
  or.push({
    query: {
      field: 'sharry_content_subtitle',
      comparator: SearchComparator.ContWordStartsWith,
      value,
    },
  });
  or.push({
    query: {
      field: 'sharry_content_keyword_contents_keyword_name',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_name',
      comparator: SearchComparator.ContWordStartsWith,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_surname',
      comparator: SearchComparator.ContWordStartsWith,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_business_name',
      comparator: SearchComparator.ContWordStartsWith,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_who_i_am',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_qualification_text',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_keyword_contents_keyword_name',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  return [...or, ...buildReducedSearchQuery(value)];
};

export const buildReducedSearchQuery = (value: string) => {
  const or = [];
  or.push({
    query: {
      field: 'sharry_content_region',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'sharry_content_searchableAddress',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'sharry_content_province',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  // or.push({
  //   query: {
  //     field: 'sharry_content_municipality',
  //     comparator: SearchComparator.ContWord,
  //     value,
  //   },
  // });
  or.push({
    query: {
      field: 'user_region',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'user_province',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  // or.push({
  //   query: {
  //     field: 'user_municipality',
  //     comparator: SearchComparator.ContWord,
  //     value,
  //   },
  // });
  or.push({
    query: {
      field: 'user_workAddress',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'featured_card_region',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'featured_card_province',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  or.push({
    query: {
      field: 'featured_card_shortAddress',
      comparator: SearchComparator.ContWord,
      value,
    },
  });
  return or;
};

export const _arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const getRotation = (
  file: File,
  callback: { (base64Image: any, rotation: any): void; (arg0: string, arg1: number): void },
) => {
  const fileReader = new FileReader();
  fileReader.onloadend = () => {
    const base64img = 'data:' + file.type + ';base64,' + _arrayBufferToBase64(fileReader.result as ArrayBuffer);
    // @ts-ignore
    const scanner = new DataView(fileReader.result);
    let idx = 0;
    let value = 1; // Non-rotated is the default
    // eslint-disable-next-line eqeqeq
    if ((fileReader.result as string)['length'] < 2 || scanner.getUint16(idx) != 0xffd8) {
      // Not a JPEG
      if (callback) {
        callback(base64img, value);
      }
      return;
    }
    idx += 2;
    let maxBytes = scanner.byteLength;
    while (idx < maxBytes - 2) {
      const uint16 = scanner.getUint16(idx);
      idx += 2;
      switch (uint16) {
        case 0xffe1: // Start of EXIF
          const exifLength = scanner.getUint16(idx);
          maxBytes = exifLength - idx;
          idx += 2;
          break;
        case 0x0112: // Orientation tag
          // Read the value, its 6 bytes further out
          // See page 102 at the following URL
          // http://www.kodak.com/global/plugins/acrobat/en/service/digCam/exifStandard2.pdf
          value = scanner.getUint16(idx + 6, false);
          maxBytes = 0; // Stop scanning
          break;
      }
    }
    if (callback) {
      callback(base64img, value);
    }
  };
  fileReader.readAsArrayBuffer(file);
};

export const resetOrientation = (
  document: Document,
  srcBase64: string,
  srcOrientation: number,
  callback: (resetBase64Image: any | string) => void,
) => {
  const img = new Image();
  img.onload = () => {
    const width = img.width;
    const height = img.height;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // set proper canvas dimensions before transform & export
    if (4 < srcOrientation && srcOrientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }
    if (ctx) {
      // transform context before drawing image
      switch (srcOrientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }
      // draw image
      ctx.drawImage(img, 0, 0);
    }
    // export base64
    callback(canvas.toDataURL());
  };
  img.src = srcBase64;
};

export const copyToClipboard = (navigator: Navigator, string: string) => {
  navigator.clipboard.writeText(string);
};

export const minSelectedCheckboxes = (min = 1) => {
  const validator = (formArray: AbstractControl) => {
    const totalSelected = (formArray as UntypedFormArray).controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => (next ? prev + next : prev), 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };
  return validator;
};
export const minArrayLength = (min = 1) => {
  const validator = (control: AbstractControl) => (control.value.length >= min ? null : { required: true });
  return validator;
};
export const millisecondsToMidnight = (isIronMaiden?: boolean) => {
  if (isIronMaiden) return 1000 * 60 * 2;
  const midnight = new Date();
  midnight.setHours(24);
  midnight.setMinutes(0);
  midnight.setSeconds(0);
  midnight.setMilliseconds(0);
  return Number(((midnight.getTime() - new Date().getTime()) / 1000).toFixed(0));
};

export const navigateToExternalUrl = (
  window: Window,
  url: string,
  openSnackBarService: OpenSnackBarService,
  translateService: ITranslationService,
  features?: string,
  event?: Event,
) => {
  if (Capacitor.isNativePlatform()) {
    Browser.open({ url })
      .then(() => console.log('in-app browser opened'))
      .catch(error => {
        console.error(error);
        import('src/app/_shared/components/generic-snack-bar/generic-snack-bar.component').then(
          ({ GenericSnackBarComponent }) =>
            openSnackBarService.openSnackBar(GenericSnackBarComponent, {
              data: { text: translateService.t('snack-bar.window.popup-blocked'), close: true },
              duration: 2000,
            }),
        );
      });
    if (event) event.preventDefault();
  } else {
    const newWindow = window.open(url, '_self', features);
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      //POPUP BLOCKED
      import('src/app/_shared/components/generic-snack-bar/generic-snack-bar.component').then(
        ({ GenericSnackBarComponent }) =>
          openSnackBarService.openSnackBar(GenericSnackBarComponent, {
            data: { text: translateService.t('snack-bar.window.popup-blocked'), close: true },
            duration: 2000,
          }),
      );
    } else {
      newWindow.focus();
    }
    if (event) event.preventDefault();
  }
};

export const mailTelTo = (window: Window, subject: string, type = 'mailto') => {
  if (Capacitor.isNativePlatform()) {
    AppLauncher.openUrl({ url: `${type}:${subject}` }).catch(() => console.error('cannot open app for: ', type));
  } else {
    window.location.href = `${type}:${subject}`;
  }
};

export const mapStyles: google.maps.MapTypeStyle[] = [
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#d7d7d7',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

export const mapStylesPublicTransport: google.maps.MapTypeStyle[] = [...mapStyles]
  .filter(s => s.featureType !== 'transit' && !(s.featureType === 'road' && s.elementType === 'labels'))
  .concat(
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'transit.line',
      stylers: [
        {
          color: '#DE911D',
        },
      ],
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry',
      stylers: [
        {
          color: '#DE911D',
        },
        {
          weight: 3,
        },
      ],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.icon',
      stylers: [
        {
          color: '#B44D12',
        },
      ],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#B44D12',
        },
      ],
    },
  );

export const mapStylesVisibilityOff: google.maps.MapTypeStyle[] = [
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#d7d7d7',
        isibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'all',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];

export const removeDuplicatesByKey = (array: any[], key = 'id'): any[] =>
  Array.from(new Set(array.map(a => a[key]))).map(id => array.find(a => a[key] === id));

export const getParticipantsString = (
  totalAdults: number,
  totalYoungsters: number,
  totalChildren: number,
  totalInfants: number,
): string => {
  let string = '(';
  if (totalAdults) {
    string += totalAdults + ' adulti,';
  }
  if (totalYoungsters) {
    string += totalYoungsters + ' ragazzi,';
  }
  if (totalChildren) {
    string += totalChildren + ' bambini,';
  }
  if (totalInfants) {
    string += totalInfants + ' neonati,';
  }
  return string.slice(0, -1) + ')';
};

export const roundCurrencyValue = (value: number) => Number((Math.round(value * 100) / 100).toFixed(2));

export class SharryErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid && (control.dirty || control.touched)) as boolean;
  }
}

export const getUnionObject = (obj1: any, obj2: any) => {
  const diff = Object.keys(obj1).filter(k => Object.keys(obj2).indexOf(k) === -1);
  diff.forEach(d => {
    delete obj1[d];
  });
  return obj1;
};

export const shouldShowStripeBanner = (userService: UserService): boolean =>
  !userService.user?.stripeAccountCompleted || !userService.user?.stripePayoutsEnabled;

export const shouldShowBillingInfoBanner = (userService: UserService): boolean => !userService.user?.billingInfoSet;

export const checkNumberNotNull = (value: number, isFloat?: boolean): boolean =>
  isFloat ? !isNaN(parseFloat(`${value}`)) : !isNaN(parseInt(`${value}`));

export const fallbackCoordinates = { latitude: 45.64872, longitude: 11.78335 };

export const urlFileToB64 = async (url: string): Promise<{ b64: string; type: string }> => {
  const blob = await (await fetch(url)).blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ b64: reader.result as string, type: blob.type });
    reader.onerror = error => reject(error);
    reader.readAsDataURL(blob);
  });
};

export const capacitorDownloadFile = (url: string, name: string) => {
  CapacitorHttp.get({ url, responseType: 'blob' })
    .then(async res => {
      const permission = await Filesystem.checkPermissions();
      if (permission.publicStorage === 'granted') {
        const urlArr = res.url.split('/');
        Filesystem.writeFile({
          data: res.data,
          path: name + '.' + (urlArr[urlArr.length - 1].split('.')[1] || ''),
          directory: Directory.Documents,
        })
          .then(fileRes => {
            FileOpener.open({ openWithDefault: true, filePath: fileRes.uri })
              .then(() => console.log('File is opened'))
              .catch((e: any) => console.log('Error opening file', e));
          })
          .catch(error => console.error(error));
      } else {
        Filesystem.requestPermissions()
          .then(() => capacitorDownloadFile(url, name))
          .catch(error => console.error(error));
      }
    })
    .catch(error => console.error(error));
};

export const getDatesBetweenTwoDates = (startDate: Date, endDate: Date): Date[] => {
  const addDays = (date: Date, days = 1) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  const dateRange = (start: Date, end: Date, range: Date[] = []): Date[] => {
    if (
      new Date(new Date(start).setHours(0, 0, 0, 0)).getTime() > new Date(new Date(end).setHours(0, 0, 0, 0)).getTime()
    ) {
      return range;
    }
    const next = addDays(start, 1);
    return dateRange(next, new Date(end), [...range, new Date(start)]);
  };
  return dateRange(startDate, endDate);
};

export const openNativeSettings = () => {
  if (Capacitor.getPlatform() === 'android') {
    NativeSettings.openAndroid({ option: AndroidSettings.Application })
      .then(r => console.log(r))
      .catch(error => console.error(error));
  } else if (Capacitor.getPlatform() === 'ios') {
    NativeSettings.openIOS({ option: IOSSettings.App })
      .then(r => console.log(r))
      .catch(error => console.error(error));
  }
};

export const openNativeAlertDialog = (
  title: string,
  message: string,
  okButtonTitle: string,
  cancelButtonTitle: string,
): Promise<ConfirmResult> =>
  Dialog.confirm({
    title,
    message,
    okButtonTitle,
    cancelButtonTitle,
  });

export enum PriceKindDateReturnable {
  SingleDate = 'single_date',
  DoubleDate = 'double_date',
  NoDate = 'no_date',
}

export const parseArray = (value: string | string[]): string[] =>
  value ? (typeof value === 'string' ? [value] : [...value]) : [];

export const isSharryContentPublished = (status: SharryContentStatus): boolean =>
  status === SharryContentStatus.Published ||
  status === SharryContentStatus.Validated ||
  status === SharryContentStatus.Suspended ||
  status === SharryContentStatus.AdminHidden;

export const eventMapToString = (
  value: { days: AvailabilityDaysEnum[]; weeks: AvailabilityWeeksEnum[] },
  translateService: ITranslationService,
): string => {
  let s = '';
  if (value.weeks.length === 5 && value.days.length === 7) {
    s += `<strong>${translateService.t('every-day')}</strong> `;
  } else {
    if (value.weeks.length === 5) {
      s += `<strong>${translateService.t('all')}</strong> `;
    } else {
      const weeksArr = value.weeks.map(
        week =>
          `${translateService.t(
            `${AvailabilityWeeksEnum[week]}${
              value.days.length === 1
                ? value.days[0] === AvailabilityDaysEnum.sunday
                  ? `-fem`
                  : ``
                : value.days.length === 2 &&
                    value.days[0] === AvailabilityDaysEnum.sunday &&
                    value.days[1] === AvailabilityDaysEnum.saturday
                  ? ``
                  : `-fem`
            }`,
          )}`,
      );
      s +=
        weeksArr.slice(0, value.weeks.length - 1).join(', ') +
        (value.weeks.length !== 1 ? ' e ' : '') +
        weeksArr[value.weeks.length - 1] +
        ' ';
    }
    // giorno singolo
    if (value.days.length === 1) {
      s += translateService.t('time-of-month', {
        time: `<strong>${translateService.t(AvailabilityDaysEnum[value.days[0]])}</strong>`,
      });
      // weekend
    } else if (
      value.days.length === 2 &&
      value.days[0] === AvailabilityDaysEnum.sunday &&
      value.days[1] === AvailabilityDaysEnum.saturday
    ) {
      s += translateService.t('time-of-month', { time: translateService.t('weekend') });
      // giorni feriali
    } else if (
      value.days.length === 5 &&
      value.days[0] === AvailabilityDaysEnum.monday &&
      value.days[1] === AvailabilityDaysEnum.tuesday &&
      value.days[2] === AvailabilityDaysEnum.wednesday &&
      value.days[3] === AvailabilityDaysEnum.thursday &&
      value.days[4] === AvailabilityDaysEnum.friday
    ) {
      s +=
        translateService.t('time-of-month', { time: translateService.t('week') }) +
        ` (<strong>${translateService.t('lun')} - ${translateService.t('ven')}</strong>)`;
      // tutta la settimana
    } else if (value.days.length === 7) {
      s +=
        translateService.t('time-of-month', { time: translateService.t('week') }) +
        ` (<strong>${translateService.t('lun')} - ${translateService.t('dom')}</strong>)`;
      // giorni misti
    } else {
      s +=
        translateService.t('time-of-month', { time: translateService.t('week') }) +
        ` (<strong>${[...value.days]
          .sort((a, b) => {
            if (a === 0 && b !== 0) {
              return 1;
            } else if (b === 0 && a !== 0) {
              return -1;
            } else {
              return a - b;
            }
          })
          .map(d => translateService.t(AvailabilityDaysEnum[d].substring(0, 3)))
          .join(', ')}</strong>)`;
    }
  }
  return s.charAt(0).toUpperCase() + s.substring(1);
};

export enum AvailabilityDaysEnum {
  sunday = 0,
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6,
}

export enum AvailabilityWeeksEnum {
  first = 0,
  second = 1,
  third = 2,
  fourth = 3,
  last = -1,
}

export type Key<T> = keyof T;

export const imageUrlToFile = (url: string): Promise<File> => {
  const urltoFile = (url2: string, filename: string) =>
    fetch(url2, { headers: { ['Access-Control-Allow-Origin']: '*' }, mode: 'no-cors' })
      .then(res => res.blob())
      .then(async blob => {
        const { default: getExtension } = await import('utils/mime');
        return new File([blob], `${filename}.${getExtension(blob.type) || 'jpg'}`, { type: blob.type });
      });
  return urltoFile(url, `pic-${new Date().toISOString()}`);
};

export const formatPercentage = (perc: number[]): number[] => {
  const intPart = perc.map(n => Math.floor(n)).reduce((a, b) => a + b, 0);
  const result = perc.map((p, i) => ({ originalIndex: i, value: p })).sort((a, b) => (b.value % 1) - (a.value % 1));
  for (let i = 0; i < 100 - intPart; i++) {
    result[i].value = result[i].value + 1;
  }
  return result.sort((a, b) => a.originalIndex - b.originalIndex).map(n => Math.floor(n.value));
};

export const detectWebpSupport = async (_document: Document): Promise<boolean> => {
  const testImageSources = [
    'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoCAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==',
    'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=',
  ];

  const testImage = (src: string): Promise<boolean> =>
    new Promise(resolve => {
      const img = _document.createElement('img');
      img.onerror = () => resolve(false);
      img.onload = () => resolve(true);
      img.src = src;
    });

  const results = await Promise.all(testImageSources.map(testImage));

  return results.every(result => !!result);
};

export const isAbsoluteUrl = (url: string) => url.startsWith('http') || url.startsWith('//');

/**
 * Deep merge two objects.
 *
 * @param target
 * @param ...sources
 */
export const mergeDeep = (...objects: any[]): any => {
  const isObject = (obj: any) => obj && typeof obj === 'object';

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        if (isObject(pVal[0]) && isObject(oVal[0])) {
          // id required
          const arrVal = pVal.map(innerPVal =>
            mergeDeep(innerPVal, oVal.find(innerOVal => innerOVal.id === innerPVal.id) || {}),
          );
          prev[key] = arrVal;
        } else {
          prev[key] = [...new Set([...oVal, ...pVal])];
        }
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
};

export const daysFromDate = (date: Date): number => {
  const now = new Date();
  date = new Date(date);
  const differenceInTime = Math.abs(now.getTime() - date.getTime());
  const differenceInDays: number = differenceInTime / (1000 * 3600 * 24);
  if (now.getHours() >= date.getHours()) {
    return Math.floor(differenceInDays);
  } else {
    return Math.ceil(differenceInDays);
  }
};

export const defaultSearchVariables: {
  filter?: SearchNode;
  sort?: SortFilter;
  count?: boolean;
  skip?: number;
  limit?: number;
  nearMap?: NearFilter;
  near?: NearFilter;
  titleFirst?: string;
  withNoDates?: boolean;
} = {
  filter: {
    and: [
      {
        or: [
          {
            and: [
              {
                query: {
                  field: 'sharry_content_content_type',
                  comparator: SearchComparator.In,
                  values: ['wonder', 'sharry', 'event'],
                },
              },
            ],
          },
        ],
      },
    ],
  },
  count: true,
  limit: 12,
  skip: 0,
};

export const SHARRY_DATE_FORMATS = {
  parse: {
    dateInput: { day: 'numeric', month: 'numeric', year: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

export const stripTagsAndFormatters = (value: string, inline = false) => {
  if (!value) return '';
  const stripped = value
    .replace(/<span(.*?)span>/gm, '')
    .replace(/<[^>]*>?/gm, '')
    .replace(/::search-results::/gm, '')
    .replace(/\*\*/gm, '')
    .replace(/--/gm, '')
    .replace(/__/gm, '')
    .replace(/~~/gm, '')
    .replace(/```/gm, '');
  return inline ? stripped.replace(/\n/gm, ' ') : stripped;
};

export const acceptedProviderUrl: string[] = [
  'https://teams.microsoft.com',
  'https://zoom.us',
  'https://us02web.zoom.us',
  'https://us03web.zoom.us',
  'https://us04web.zoom.us',
  'https://us05web.zoom.us',
  'https://us06web.zoom.us',
  'https://us07web.zoom.us',
  'https://meet.google.com',
  'https://www.sharry.land',
  'https://frontend-staging.sharry.land',
  'https://www.youtube.com',
  'https://youtu.be/',
  'https://we.tl',
];

export const baseUrl = environment.baseUrl;

export const idsearchCategoriesSuMisura =
  environment.env === 'production'
    ? ['953', '954', '955', '962', '971', '970', '959', '960', '961', '963', '965', '966', '968', '994', '995', '996']
    : ['171', '166', '123', '121', '120', '118', '117', '116', '115', '114', '113', '112', '111', '110', '109', '108'];

export const onAddEmoji = (emoji: string, editor: Quill) => {
  const start = editor.getSelection(true).index;
  editor.insertText(start, emoji, 'user');
  editor.setSelection(start + emoji.length, 0, 'user');
};

export type TypedForm<T> = {
  [K in keyof T]: FormControl<T[K]>;
};

const createPolicy = (window: any) => {
  const policy = window.trustedTypes.createPolicy('default', {
    createHTML: (input: string) => input,
    createScriptURL: (input: string) => input,
    createScript: (input: string) => input,
  });
  window.defaultTrustedTypesPolicy = policy;
  return policy;
};

export const trustedTypesPolicy = (window: any) => {
  if (window.trustedTypes && window.trustedTypes.createPolicy) {
    if (window.defaultTrustedTypesPolicy) {
      return window.defaultTrustedTypesPolicy;
    } else {
      return createPolicy(window);
    }
  }
  return null;
};
export const sharrylandId = environment.env === 'production' ? '3215' : '1453';

export const cdn =
  'https://' + (environment.env === 'production' ? 'd3gd1yc37idnqe' : 'd27b6hlr7tfmf0') + '.cloudfront.net';

export const LANGUAGE_SERVER_ID = new InjectionToken<string>('language id fom server');

export enum CurrencySymbol {
  USD = '$',
  CAD = '$',
  AUD = '$',
  BRL = 'R$',
  CHF = '₣',
  CNY = '¥',
  HKD = '$',
  MXN = '$',
  NZD = '$',
  SGD = '$',
  EUR = '€',
  GBP = '£',
  ILS = '₪',
  INR = '₹',
  JPY = '¥',
  KRW = '₩',
  PHP = '₱',
  PLN = 'zł',
  THB = '฿',
  TRY = '₺',
  BGN = 'BGN',
  CZK = 'Kč',
  DKK = 'kr',
  HUF = 'Ft',
  IDR = 'Rp',
  ISK = 'kr',
  MYR = 'RM',
  NOK = 'kr',
  RON = 'lei',
  SEK = 'kr',
  ZAR = 'R',
}

export const removeArrayDuplicates = (
  arr: { id: string; [key: string]: any }[],
): { id: string; [key: string]: any }[] => {
  const uniqueIds: Record<string, boolean> = {}; // Use an object to track unique IDs
  return arr.filter(obj => {
    if (!uniqueIds[obj.id]) {
      uniqueIds[obj.id] = true;
      return true; // Include the object if the ID is unique
    }
    return false; // Exclude duplicates
  });
};
